import { PageHeader } from "../../components/PageHeader";
import { WrapperContent } from "../../components/WrapperContent";

export default function NotFound() {
  return (
    <WrapperContent>
      <PageHeader title="Página no encontrada" />
    </WrapperContent>
  );
}
